import tw from "tailwind-styled-components";
import { FaCheckCircle, FaTimesCircle, FaClock, FaPercentage, FaMoneyBillWave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function StaffAttendanceMetrics({ summaryData }) {
    const metrics = [
        {
            label: "Present",
            value: summaryData?.present || 0,
            icon: FaCheckCircle,
            color: "text-green-600",
            bgColor: "bg-green-50",
            borderColor: "border-green-200"
        },

        {
            label: "Half Day",
            value: summaryData?.halfDay || 0,
            icon: FaClock,
            color: "text-orange-600",
            bgColor: "bg-orange-50",
            borderColor: "border-orange-200"
        },
        {
            label: "Absent",
            value: summaryData?.absent || 0,
            icon: FaTimesCircle,
            color: "text-red-600",
            bgColor: "bg-red-50",
            borderColor: "border-red-200"
        },
        {
            label: "Attendance %",
            value: `${summaryData?.attendancePercentage || 0}%`,
            icon: FaPercentage,
            color: "text-purple-600",
            bgColor: "bg-purple-50",
            borderColor: "border-purple-200"
        },
        {
            label: "Salary Deducted",
            value: `${summaryData?.salaryDeductionDays || 0} Days`,
            icon: FaMoneyBillWave,
            color: "text-rose-600",
            bgColor: "bg-rose-50",
            borderColor: "border-rose-200"
        },
    ];

    return (
        <Container>
            <HeaderRow>
                <MetricsRow>
                    <MetricsScroll>
                        {metrics.map((item, index) => (
                            <Metric key={index}>
                                <MetricLabel>{item.label}</MetricLabel>
                                <MetricValue className={item.color}>
                                    {item.value}
                                </MetricValue>
                            </Metric>
                        ))}
                    </MetricsScroll>
                </MetricsRow>
            </HeaderRow>
            <ContextNote>
                Attendance summary for the selected month
            </ContextNote>
        </Container>
    );
}

const Container = tw.div`
  mt-2 md:mt-6
  bg-white rounded-lg shadow-sm
  px-4 py-4 md:px-6
`;

const HeaderRow = tw.div`
  flex items-start justify-between
  w-full
`;

const MetricsScroll = tw.div`
  flex gap-2
  overflow-x-auto
  scrollbar-hide
  justify-end
  pb-1
  grid md:grid-cols-6 grid-cols-3
`;

const Metric = tw.div`
  min-w-[110px]
  flex-shrink-0
  cursor-pointer
  group
`;

const MetricLabel = tw.div`
  text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500
  whitespace-nowrap
`;

const MetricValue = tw.div`
  flex items-center gap-1
  text-lg font-semibold
  transition-colors
`;

const MetricsRow = tw.div`
  flex-1 
   min-w-0
`;

const ContextNote = tw.div`
  mt-0
  -mb-2
  pr-0
  text-[10px]
  text-gray-300
  text-right
  hidden lg:block
  leading-tight
`;

export default StaffAttendanceMetrics;